import React, { useState } from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { useClientId } from '../../../_hooks/useClientId';
import { ErrorState } from '../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { FullPageLoading } from '../../../CommonComponents/OPL/FullpageLoading/FullPageLoading';
import { useBalanceSheetQuery } from '../../api/useBalanceSheetQuery';
import { SegmentedControl } from '../../../CommonComponents/OPL/SegmentedControl/SegmentedControl';
import { Summary } from './tabs/Summary/Summary';
import { Details } from './tabs/Details/Details';
import { TrustsAndEntities } from './tabs/TrustsAndEntities/TrustsAndEntities';

const TRUSTS_AND_ENTITIES_ENABLED = { 'Trusts & Entities Summary': TrustsAndEntities };

const COMPONENT_MAP = {
  'Net Worth Summary': Summary,
  'Net Worth Details': Details,
};

export const DetailNetWorth = () => {
  const clientId = useClientId();
  const { data, isLoading, error, refetch } = useBalanceSheetQuery({ clientId });

  const [selectedIndex, setSelectedIndex] = useState(0);

  if (isLoading) {
    return <FullPageLoading />;
  }

  if (error) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" py="24" height="100%">
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  const Components =
    data.EntityLevelSummaries.length === 0
      ? COMPONENT_MAP
      : { ...COMPONENT_MAP, ...TRUSTS_AND_ENTITIES_ENABLED };

  const tabNameList = Object.keys(Components);

  return (
    <Box
      width="100%"
      display="flex"
      flexDirection="column"
      css={({ theme }) => ({ gap: theme.space['48'] })}
    >
      <SegmentedControl
        id="default"
        values={tabNameList}
        selectedIndex={selectedIndex}
        onChange={setSelectedIndex}
      />

      {selectedIndex === 0 && <Summary data={data.Summary} />}

      {selectedIndex === 1 && (
        <Details
          data={{
            inEstateSummary: data.InEstateSummary,
            outOfEstateSummary: data.OutOfEstateSummary,
          }}
        />
      )}

      {selectedIndex === 2 && <TrustsAndEntities data={data.EntityLevelSummaries} />}
    </Box>
  );
};
